<template>
  <a :href="props.link">
    <v-card hover>
      <v-img
        :src="props.image"
        class="align-end"
        :class="{
          'd-flex justify-center align-center text-center': props.buttonOnly,
        }"
        gradient="to bottom, rgba(17,39,51,.1) 0%, rgba(17,39,51,0.65) 64%, rgba(17,39,51,.96) 100%"
        height="300px"
        cover
      >
        <template v-if="props.buttonOnly">
          <v-btn class="text-none" elevation="0" size="large" :ripple="false">
            {{ props.buttonOnly }}
          </v-btn>
        </template>
        <template v-if="!props.buttonOnly">
          <v-btn class="tag-button text-none" elevation="0" :ripple="false">
            {{ props.tag }}
          </v-btn>
          <v-card-title class="text-white text-h5">
            {{ props.title }}
          </v-card-title>
          <v-card-subtitle class="text-white mb-4 font-weight-bold text-body-1">
            {{ props.description }}
          </v-card-subtitle>
        </template>
      </v-img>
    </v-card>
  </a>
</template>

<script setup lang="ts">
const props = defineProps<{
  title?: string
  description?: string
  tag?: string
  buttonOnly?: string
  link: string
  image: string
}>()
</script>

<style scoped>
.tag-button {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>
